export default "__VITE_ASSET__C8apg1vV__"